/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { drugCategoryDropdouwnData } from './constant';

import {
  amountComparator
} from '../../../../SharedModules/utilities/utilities';
export const NDC_AVAILABILITY_TABLEHEAD = [
  {
    headerName: 'NDC',
    field: 'ndc',
    headerCheckboxSelection: true,
    checkboxSelection: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const REQUEST_DRUG_PRICE_LOAD_MFG_TABLE_HEAD = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    minWidth: 160,
    sort: 'asc',
    maxLength: Styles.Length_255,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    resizable: false,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const REQUEST_DRUG_PRICE_LOAD_DETAILS_PRICE_TABLEHEAD = (
  type = 'Single',
  referenceData,
  readOnly = true
) => {
  const tableHead = [];
  tableHead.push(
    ...[
      {
        headerName: 'Comments Exists',
        field: 'ccCommentsExist',
        filter: false,
        sortable: false,
        enableMenu: false,
        showCheckboxIcon: true,
        minWidth: Styles.Width_158,
        maxWidth: Styles.Width_180,
        resizable: true,
        editable: false,
        suppressMenu: false,
        cellEditor: MaxLengthNumericEditor,
        cellRenderer: 'ActionCellRender',
        cellStyle: { 'border-right-color': Styles.BorderColor },
      },
      {
        headerName: 'Target Quarter',
        field: 'targetQtr',
        cellRenderer: 'textFieldComponent',
        cellRendererParams: (params) => ({
          maxLength: 6,
          disabled: readOnly || !params.data.isAddedFromUI,
        }),
        sortable: true,
        minWidth: 165,
        maxLength: Styles.Length_255,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Labeler Code',
        field: 'labelerCode',
        cellRenderer: 'textFieldComponent',
        cellRendererParams: {
          type: 'number',
          textAlign: 'right',
          maxLength: 5,
          disabled: true,
        },
        sortable: true,
        minWidth: 160,
        maxLength: Styles.Length_255,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Product Code',
        field: 'productCode',
        cellRenderer: 'textFieldComponent',
        cellRendererParams: (params) => ({
          type: 'number',
          textAlign: 'right',
          maxLength: 4,
          disabled: readOnly || !params.data.isAddedFromUI,
        }),
        sortable: true,
        minWidth: 160,
        maxLength: Styles.Length_255,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Package Size',
        field: 'packageSize',
        cellRenderer: 'textFieldComponent',
        cellRendererParams: (params) => ({
          type: 'number',
          textAlign: 'right',
          maxLength: 2,
          disabled: readOnly || !params.data.isAddedFromUI,
        }),
        sortable: true,
        minWidth: 160,
        maxLength: Styles.Length_255,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        filter: 'agTextColumnFilter',
      },
    ]
  );

  if (type === 'Single') {
    tableHead.push({
      headerName: 'Price',
      field: 'price',
      cellRenderer: 'textFieldComponent',
      excelAlignment: 'right',
      isBgColor: true,
      dataAlignRight: true,
      isTextColorRed: true,
      exportZeroesSix: true,
      printPrefixValue: '',
      cellRendererParams: {
        type: 'number',
        maxLength: 22,
        beforeDecimal: 15,
        afterDecimal: 6,
        disabled: readOnly,
      },
      sortable: true,
      sortingOrder: ['asc', 'desc'],
      comparator: amountComparator,
 
      minWidth: 160,
      maxLength: Styles.Length_255,
      cellStyle: {
        'border-right-color': Styles.BorderColor,
        textAlign: 'right',
      },
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
      filter: 'agTextColumnFilter',
    });
  } else {
    tableHead.push(
      ...[
        {
          headerName: 'AMP',
          field: 'price',
          cellRenderer: 'textFieldComponent',
          excelAlignment: 'right',
          isBgColor: true,
          dataAlignRight: true,
          isTextColorRed: true,
          exportZeroesSix: true,
          printPrefixValue: '',
          cellRendererParams: {
            type: 'number',
            maxLength: 22,
            beforeDecimal: 15,
            afterDecimal: 6,
            disabled: readOnly,
          },
          sortable: true,
          sortingOrder: ['asc', 'desc'],
          comparator: amountComparator,
          minWidth: 160,
          maxLength: Styles.Length_255,
          cellStyle: {
            'border-right-color': Styles.BorderColor,
            textAlign: 'right',
          },
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Best Price',
          sortingOrder: ['asc', 'desc'],
          comparator: amountComparator,
          field: 'bestPrice',
          cellRenderer: 'textFieldComponent',
          cellRendererParams: {
            type: 'number',
            textAlign: 'right',
            maxLength: 22,
            beforeDecimal: 15,
            afterDecimal: 6,
            disabled: readOnly,
          },
          sortable: true,
          minWidth: 160,
          maxLength: Styles.Length_255,
          cellStyle: { 'border-right-color': Styles.BorderColor },
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          filter: 'agTextColumnFilter',
        },
      ]
    );
  }

  tableHead.push(
    ...[
      {
        headerName: 'Drug Category',
        field: 'drugCatCd',
        cellRenderer: 'dropDownComponent',
        cellRendererParams: {
          dropdownData:
            (referenceData &&
              referenceData.DRUG_CAT_CD &&
              referenceData.DRUG_CAT_CD?.map((item) => {
                return {
                  label: item.codeValueID && drugCategoryDropdouwnData[item.codeValueID.codeValue],
                  value: item.codeValueID && item.codeValueID.codeValue,
                };
              })) ||
            [],
          disabled: readOnly,
        },
        sortable: true,
        minWidth: 220,
        maxLength: Styles.Length_255,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        filter: 'agTextColumnFilter',
      },
    ]
  );
  return tableHead;
};

export const REQUEST_DRUG_PRICE_LOAD_DETAILS_URA_TABLEHEAD = (readOnly) => [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_158,
    maxWidth: Styles.Width_180,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Target Quarter',
    field: 'targetQtr',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: (params) => ({
      maxLength: 6,
      disabled: readOnly || !params.data.isAddedFromUI,
    }),
    sortable: true,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      type: 'number',
      textAlign: 'right',
      maxLength: 5,
      disabled: true,
    },
    sortable: true,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Product Code',
    field: 'productCode',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: (params) => ({
      type: 'number',
      textAlign: 'right',
      maxLength: 4,
      disabled: readOnly || !params.data.isAddedFromUI,
    }),
    sortable: true,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Package Size',
    field: 'packageSize',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: (params) => ({
      type: 'number',
      textAlign: 'right',
      maxLength: 2,
      disabled: readOnly || !params.data.isAddedFromUI,
    }),
    sortable: true,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'URA',
    field: 'calcUra',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      type: 'number',
      textAlign: 'right',
      maxLength: 22,
      beforeDecimal: 15,
      afterDecimal: 6,
      disabled: readOnly,
    },
    sortable: true,
    comparator: amountComparator,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    filter: 'agTextColumnFilter',
  },
];
